// Тест и отчёт — без автоперевода браузера (26.10.2026). Жалоба 19.10:
// на скриншотах опечатки и пустые варианты ответов — так выглядит страница,
// которую Chrome перевёл сам: перевод ломает варианты и подсовывает чужие слова.
// Здесь — адреса, где <html translate="no"> и <meta name="google" content="notranslate">
// ставит src/routes/__root.tsx. Мини-тест на главной — атрибутом на самом блоке
// (FreeCheck в src/components/home/HomePage.tsx): переводить остальную главную можно;
// /test и /az/test — переход на главную с ?mini=1. Без импортов: модуль читает
// scripts/verify-no-translate.mts.

/** Анкета /start, сессия теста и отчёт по ней, превью отчётов, страницы бесплатного теста, анкета и отчёт «Учёба за рубежом». */
export function noTranslatePath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return (
    /^\/start$/.test(p) ||
    /^\/(besplatnyy-test-proforientatsii|az\/pulsuz-karyera-testi|en\/free-career-test)$/.test(p) ||
    /^\/session\/[^/]+(\/(test|result|print))?$/.test(p) ||
    /^\/report\/[^/]+/.test(p) ||
    // «Учёба за рубежом» (27.10.2026): анкета, отчёт, печатный отчёт, отчёт в кабинете.
    /^\/(study-abroad|az\/xaricde-tehsil|en\/study-abroad)\/(start|r\/[^/]+)$/.test(p) ||
    /^\/abroad-report\/[^/]+$/.test(p) ||
    /^\/cabinet\/edu-report$/.test(p)
  );
}
